import {baseLanggraphApiSlice} from "./baseApiSliceLanggraph";
import {CreateBackgroundRunConfigModel, SearchThreadModel, ThreadModel} from "../../../types/langgraph/thread";

export const langgraphApiSlice = baseLanggraphApiSlice.injectEndpoints({
    endpoints: builder => ({
        searchThread: builder.mutation<any, SearchThreadModel>({
            query: (params) => {
                return {
                    url: `/threads/search`,
                    method: 'POST',
                    body: {...params}
                }
            }
        }),
        createThread: builder.mutation<ThreadModel, void>({
            query: () => {
                return {
                    url: `/threads`,
                    method: 'POST',
                    body: {}
                }
            }
        }),
        createThreadBackgroundRun: builder.mutation<any, { thread_id: string, config: CreateBackgroundRunConfigModel }>({
            query: (params) => {
                return {
                    url: `/threads/${params.thread_id}/runs`,
                    method: 'POST',
                    body: {...params.config}
                }
            }
        }),
        getThoughts: builder.mutation<any, {negotiation_uuid: string, field: string}>({
            query: (params) => {
                return {
                    url: `/erik/thoughts/get-field/`,
                    method: 'POST',
                    body: {...params}
                }
            }
        })
    })
})

export const {useSearchThreadMutation, useCreateThreadMutation, useCreateThreadBackgroundRunMutation, useGetThoughtsMutation} = langgraphApiSlice